import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { RpServiceChangeRequestDataResponse } from "@idw-types/data/rp-service-change-request";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithQueryParams } from "@utils/http-util";

export const getRpServiceChangeRequest = async (
    rpServiceId: string,
): Promise<GenericNetworkResponse<RpServiceChangeRequestDataResponse>> => {
    const queryParameters: Array<QueryParameter> = [
        { parameter: "rpServiceID", value: rpServiceId }
    ];

    const { data, error } = await handleRequestWithQueryParams(
        RequestTypes.GET,
        apiRoutes.serviceConfiguration.data.rpServiceChangeRequest,
        queryParameters
    );

    return { data, error, queryParameters };
};
